import useLocalStorageManager, {
  LS_NAMES,
} from '@/composables/localStorage/localStorageManager'
import useCurrentUser from '@/composables/user/user'

class BlockedUsersCache {
  userId: number
  lastActivity: number
  blockedUserIds: Array<number>

  constructor(
    userId: number,
    lastActivity: number,
    blockedUserIds: Array<number>
  ) {
    this.userId = userId
    this.lastActivity = lastActivity
    this.blockedUserIds = blockedUserIds
  }
}

export default function useUserBlockCache() {
  function getBlockedUserCacheFromObject(
    object: Record<string, any>
  ): undefined | BlockedUsersCache {
    let userId: number | undefined
    let lastActivity: number | undefined
    let blockedUserIds: Array<number> | undefined

    if (Object.prototype.hasOwnProperty.call(object, 'userId')) {
      userId = parseInt(object.userId)
    }
    if (Object.prototype.hasOwnProperty.call(object, 'lastActivity')) {
      lastActivity = parseInt(object.lastActivity)
    }
    if (
      Object.prototype.hasOwnProperty.call(object, 'blockedUserIds') &&
      typeof object.blockedUserIds === 'object'
    ) {
      blockedUserIds = object.blockedUserIds
    }

    if (
      typeof userId !== 'undefined' &&
      typeof lastActivity !== 'undefined' &&
      typeof blockedUserIds !== 'undefined'
    ) {
      return new BlockedUsersCache(userId, lastActivity, blockedUserIds)
    }
  }
  function getBlockedUsersFromCache() {
    const { getItem } = useLocalStorageManager()
    const data = getItem(LS_NAMES.USER_BLACKLIST)

    if (data) {
      try {
        return getBlockedUserCacheFromObject(JSON.parse(data))
      } catch (e) {
        return
      }
    }
  }
  function flushBlockedUsersToCache(blockedUserIds: Array<number>) {
    const { currentUser } = useCurrentUser()
    const { setItem } = useLocalStorageManager()

    if (currentUser.value) {
      setItem(
        LS_NAMES.USER_BLACKLIST,
        JSON.stringify(
          new BlockedUsersCache(
            currentUser.value.id,
            currentUser.value.activity.blockedUsersModifiedAt.getTime(),
            blockedUserIds
          )
        )
      )
    }
  }

  return {
    getBlockedUsersFromCache,
    flushBlockedUsersToCache,
  }
}
